import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    options: {
      margin: 8,
      display: 'flex',
      alignItems: 'center',
      border: `1px solid ${palette.gray}`,
      cursor: 'pointer',
      borderRadius: 30,
      padding: '4px 8px',
      '& .MuiCheckbox-root': { padding: '0px 2px 0px 0px !important' },
      overflow: 'hidden',
    },
    optionsSelected: {
      border: `1px solid ${palette.green}`,
      cursor: 'pointer',
      backgroundColor: palette.lightGreen,
      padding: '4px 6px',
    },
    ghostCheckIcon: { fontSize: 0, color: palette.white },
    activeAllText: {
      fontSize: 15,
      fontWeight: 500,
      marginRight: 6,
    },
    optionTextSelected: {
      fontSize: 15,
      fontWeight: 500,
      color: palette.green,
      marginRight: 6,
    },
    optionTextNewTag: {
      fontSize: 15,
      fontWeight: 500,
      marginRight: -25,
    },
    optionTextNewTagSelected: {
      fontSize: 15,
      fontWeight: 500,
      color: palette.green,
      marginRight: -25,
    },
    checkIcon: { fontSize: 16, color: palette.green },

    body: {
      background: palette.lightGray,
      fontFamily: 'sans-serif',
    },
    ribbon: {
      top: -11,
      left: 18,
      color: palette.lightGray,
      width: 35,
      bottom: 25,
      padding: 0,
      position: 'relative',
      fontSize: 9,
      transform: 'rotate(45deg)',
      textAlign: 'center',
      backgroundColor: palette.status.success,
    },
    newTagText: {
      fontSize: 6,
      color: palette.grey900,
      padding: '10px 0px 0px 9px',
      width: 20,
      fontWeight: 600,
    },
  });
